// extracted by mini-css-extract-plugin
export default {"main":"speedgame_main__OwBS-"};